import type { PartnerListResponse } from '@/app/cc/_types/types';
import { createFetch } from '@/lib/cc/commonFetch';

export default async function getPartnerList(bjdCd: string, page: number, limit: number) {
  const fetch = createFetch('town');
  const data = await fetch<PartnerListResponse>(`/agency`, {
    method: 'GET',
    params: {
      bjdCd,
      sort: 'name',
      page,
      limit,
      sSafeCareJoin: 'Y',
    },
  });
  return data.data;
}
